import { Box } from "@mui/material";

import CardHeader from "../CardHeader";
import styles from "./styles";

interface Props {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  chip?: React.ReactNode;
  iconSx?: object;
  titleSx?: object;
  headerSx?: object;
  sx?: object;
  children?: React.ReactNode;
}

const HomeCard = ({
  icon,
  title,
  subtitle,
  chip,
  iconSx,
  titleSx,
  headerSx,
  sx,
  children,
}: Props) => (
  <Box sx={{ ...styles.card, ...sx }}>
    <CardHeader
      icon={icon}
      title={title}
      subtitle={subtitle}
      chip={chip}
      iconSx={iconSx}
      titleSx={titleSx}
      sx={headerSx}
    />
    {children}
  </Box>
);

export default HomeCard;
